import React from 'react';

const Nebraska = () => (
  <svg
    width="110"
    height="55"
    viewBox="0 0 110 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M109.538 53.6323C81.6029 55.118 52.4497 53.3859 25.0706 52.6114C24.6763 46.4154 25.8591 41.7966 25.5845 35.7133C17.7136 34.5375 8.32208 34.8825 0.500488 33.6644C1.52835 22.751 1.6762 10.9505 3.06311 0.38916C18.1149 2.3254 38.2357 2.10714 54.7659 3.45899C59.5673 3.85328 65.0234 2.64224 69.0996 3.45899C71.2187 3.88848 73.0351 5.57124 75.2457 6.5288C75.7103 6.73299 76.1538 7.00055 76.2665 7.54974C77.766 8.02148 77.8012 6.28942 78.8291 6.01482C80.1667 5.65574 83.4122 6.71891 84.9751 5.50084C86.362 5.66982 85.7636 6.91606 87.0238 7.54974C88.0798 8.07781 89.7343 7.54974 90.6072 8.06372C91.5577 8.61995 92.3673 10.007 93.1699 10.6266C94.1907 11.4081 94.9158 12.0348 96.2394 12.1615C95.1974 13.3796 97.2179 14.9215 97.2602 15.7453C97.3165 16.7029 96.7885 17.7731 98.288 19.3291C98.7175 19.7798 98.8301 20.6669 99.3089 21.892C99.8369 23.2439 100.78 24.4127 100.33 27.5247C100.365 29.0244 101.893 29.0315 102.378 30.0876C102.864 30.8269 102.273 32.1506 102.378 32.6505C102.632 33.8756 103.28 33.7982 103.399 34.6994C103.547 35.8189 102.857 36.0301 102.885 36.7483C102.892 36.861 103.378 37.6707 103.399 38.2832C103.427 39.0929 103.47 38.938 103.399 39.8181C103.202 42.3388 104.35 44.8735 105.448 46.9858C105.582 47.2392 105.708 48.1053 105.962 48.5207C106.602 49.5979 109.404 51.2173 109.538 53.6323Z"
      fill="#FC374D"
    />
  </svg>
);

export default Nebraska;
